import React from 'react';

// React Router Dom
import { Link } from 'react-router-dom';

// PropTypes
import PropTypes from 'prop-types';

// Typohraphy
import { H5, Body2, Body3 } from '../../themes/typography';

// CSS Styles
import '../../styles/components/VenueMapLocation.css';

export default function VenueMapLocation({
    venueName = 'City Art Gallery West End, New York',
    venueAddress = '52 San Adres New Your City, London, USA',
    venueImage,
    venueDirectionLink = '/event-direction'
}) {
    return (
        <div className="venue-map-location-container">
            {/* Venue Title */}
            <H5 fontWeight={600}>Venue Location</H5>

            {/* Venue Name and Address Section */}
            <section className="venue-name-address">
                <Body2>{venueName}</Body2>
                <Body3>{venueAddress}</Body3>
            </section>

            {/* Map Box Section */}
            {venueImage && (
                <section className="map-location-box">
                    <div className="venue-location-box">
                        <img src={venueImage} alt="venue-location" />
                    </div>
                </section>
            )}

            {/* Direction Link Section */}
            <section className="venue-direction-link">
                <Link to={venueDirectionLink}>
                    <Body3 style={{ textDecoration: 'underline' }}>Direction</Body3>
                </Link>
            </section>
        </div>
    );
}

// PropTypes Validation
VenueMapLocation.propTypes = {
    venueName: PropTypes.string,
    venueAddress: PropTypes.string,
    venueDirectionLink: PropTypes.string,
    venueImage: PropTypes.string
};

// Direction will be the venue address link that will redirect to the google map location.
// venueImage only pass if the venue is selected from our platform. else do not pass venueImage prop.
